export const recaptchaSiteKey = '6Ldmx5AfAAAAAE0fkn5zdeGa1YeYUQoC91pdpy5Q';
export const nameValidationRegex = /^([a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,.'-\s])+$/;
export const emailValidationRegex = /^\b[\w-+\.]+@((?!gmail|googlemail|yahoo|hotmail|example|mail|email|example1|example2|company).)[\w-.]+\.\w{2,4}\b/i;
export const emailValidationRegexAllowPersonal = /^\b[\w-+\.]+@((?!googlemail|example|mail|email|example1|example2|company).)[\w-.]+\.\w{2,4}\b/i;

export const countryList = [
    {"countryCode": "NO", "name": "Norway"},
    {"countryCode": "DK", "name": "Denmark"},
    {"countryCode": "GB", "name": "United Kingdom"},
    {"countryCode": "AF", "name": "Afghanistan"},
    {"countryCode": "AX", "name": "Aland Islands"},
    {"countryCode": "AL", "name": "Albania"},
    {"countryCode": "DZ", "name": "Algeria"},
    {"countryCode": "AS", "name": "American Samoa"},
    {"countryCode": "AD", "name": "Andorra"},
    {"countryCode": "AO", "name": "Angola"},
    {"countryCode": "AI", "name": "Anguilla"},
    {"countryCode": "AQ", "name": "Antarctica"},
    {"countryCode": "AG", "name": "Antigua and Barbuda"},
    {"countryCode": "AR", "name": "Argentina"},
    {"countryCode": "AM", "name": "Armenia"},
    {"countryCode": "AW", "name": "Aruba"},
    {"countryCode": "AC", "name": "Ascension Island"},
    {"countryCode": "AU", "name": "Australia"},
    {"countryCode": "AT", "name": "Austria"},
    {"countryCode": "AZ", "name": "Azerbaijan"},
    {"countryCode": "BS", "name": "Bahamas"},
    {"countryCode": "BH", "name": "Bahrain"},
    {"countryCode": "BB", "name": "Barbados"},
    {"countryCode": "BD", "name": "Bangladesh"},
    {"countryCode": "BY", "name": "Belarus"},
    {"countryCode": "BE", "name": "Belgium"},
    {"countryCode": "BZ", "name": "Belize"},
    {"countryCode": "BJ", "name": "Benin"},
    {"countryCode": "BM", "name": "Bermuda"},
    {"countryCode": "BT", "name": "Bhutan"},
    {"countryCode": "BW", "name": "Botswana"},
    {"countryCode": "BO", "name": "Bolivia"},
    {"countryCode": "BA", "name": "Bosnia and Herzegovina"},
    {"countryCode": "BV", "name": "Bouvet Island"},
    {"countryCode": "BR", "name": "Brazil"},
    {"countryCode": "IO", "name": "British Indian Ocean Territory"},
    {"countryCode": "BN", "name": "Brunei Darussalam"},
    {"countryCode": "BG", "name": "Bulgaria"},
    {"countryCode": "BF", "name": "Burkina Faso"},
    {"countryCode": "BI", "name": "Burundi"},
    {"countryCode": "KH", "name": "Cambodia"},
    {"countryCode": "CM", "name": "Cameroon"},
    {"countryCode": "CA", "name": "Canada"},
    {"countryCode": "CV", "name": "Cape Verde"},
    {"countryCode": "KY", "name": "Cayman Islands"},
    {"countryCode": "CF", "name": "Central African Republic"},
    {"countryCode": "TD", "name": "Chad"},
    {"countryCode": "CL", "name": "Chile"},
    {"countryCode": "CN", "name": "China"},
    {"countryCode": "CX", "name": "Christmas Island"},
    {"countryCode": "CC", "name": "Cocos (Keeling) Islands"},
    {"countryCode": "CO", "name": "Colombia"},
    {"countryCode": "KM", "name": "Comoros"},
    {"countryCode": "CG", "name": "Congo"},
    {"countryCode": "CD", "name": "Congo, Democratic Republic"},
    {"countryCode": "CK", "name": "Cook Islands"},
    {"countryCode": "CR", "name": "Costa Rica"},
    {"countryCode": "CI", "name": "Cote D'Ivoire (Ivory Coast)"},
    {"countryCode": "HR", "name": "Croatia (Hrvatska)"},
    {"countryCode": "CU", "name": "Cuba"},
    {"countryCode": "CY", "name": "Cyprus"},
    {"countryCode": "CZ", "name": "Czechia (Czech Republic)"},
    {"countryCode": "DJ", "name": "Djibouti"},
    {"countryCode": "DM", "name": "Dominica"},
    {"countryCode": "DO", "name": "Dominican Republic"},
    {"countryCode": "TP", "name": "East Timor"},
    {"countryCode": "EC", "name": "Ecuador"},
    {"countryCode": "EG", "name": "Egypt"},
    {"countryCode": "SV", "name": "El Salvador"},
    {"countryCode": "GQ", "name": "Equatorial Guinea"},
    {"countryCode": "ER", "name": "Eritrea"},
    {"countryCode": "EE", "name": "Estonia"},
    {"countryCode": "ET", "name": "Ethiopia"},
    {"countryCode": "EU", "name": "European Union"},
    {"countryCode": "FK", "name": "Falkland Islands (Malvinas)"},
    {"countryCode": "FO", "name": "Faroe Islands"},
    {"countryCode": "FJ", "name": "Fiji"},
    {"countryCode": "FI", "name": "Finland"},
    {"countryCode": "FR", "name": "France"},
    {"countryCode": "FX", "name": "France, Metropolitan"},
    {"countryCode": "GF", "name": "French Guiana"},
    {"countryCode": "PF", "name": "French Polynesia"},
    {"countryCode": "TF", "name": "French Southern Territories"},
    {"countryCode": "MK", "name": "North Macedonia"},
    {"countryCode": "GA", "name": "Gabon"},
    {"countryCode": "GM", "name": "Gambia"},
    {"countryCode": "GE", "name": "Georgia"},
    {"countryCode": "DE", "name": "Germany"},
    {"countryCode": "GH", "name": "Ghana"},
    {"countryCode": "GI", "name": "Gibraltar"},
    {"countryCode": "GB", "name": "Great Britain (UK)"},
    {"countryCode": "GR", "name": "Greece"},
    {"countryCode": "GL", "name": "Greenland"},
    {"countryCode": "GD", "name": "Grenada"},
    {"countryCode": "GP", "name": "Guadeloupe"},
    {"countryCode": "GU", "name": "Guam"},
    {"countryCode": "GT", "name": "Guatemala"},
    {"countryCode": "GG", "name": "Guernsey"},
    {"countryCode": "GN", "name": "Guinea"},
    {"countryCode": "GW", "name": "Guinea-Bissau"},
    {"countryCode": "GY", "name": "Guyana"},
    {"countryCode": "HT", "name": "Haiti"},
    {"countryCode": "HM", "name": "Heard and McDonald Islands"},
    {"countryCode": "HN", "name": "Honduras"},
    {"countryCode": "HK", "name": "Hong Kong"},
    {"countryCode": "HU", "name": "Hungary"},
    {"countryCode": "IS", "name": "Iceland"},
    {"countryCode": "IN", "name": "India"},
    {"countryCode": "ID", "name": "Indonesia"},
    {"countryCode": "IR", "name": "Iran"},
    {"countryCode": "IQ", "name": "Iraq"},
    {"countryCode": "IE", "name": "Ireland"},
    {"countryCode": "IL", "name": "Israel"},
    {"countryCode": "IM", "name": "Isle of Man"},
    {"countryCode": "IT", "name": "Italy"},
    {"countryCode": "JE", "name": "Jersey"},
    {"countryCode": "JM", "name": "Jamaica"},
    {"countryCode": "JP", "name": "Japan"},
    {"countryCode": "JO", "name": "Jordan"},
    {"countryCode": "KZ", "name": "Kazakhstan"},
    {"countryCode": "KE", "name": "Kenya"},
    {"countryCode": "KI", "name": "Kiribati"},
    {"countryCode": "KP", "name": "Republic of Korea"},
    {"countryCode": "KR", "name": "South Korea"},
    {"countryCode": "XK", "name": "Kosovo*"},
    {"countryCode": "KW", "name": "Kuwait"},
    {"countryCode": "KG", "name": "Kyrgyzstan"},
    {"countryCode": "LA", "name": "Laos"},
    {"countryCode": "LV", "name": "Latvia"},
    {"countryCode": "LB", "name": "Lebanon"},
    {"countryCode": "LI", "name": "Liechtenstein"},
    {"countryCode": "LR", "name": "Liberia"},
    {"countryCode": "LY", "name": "Libya"},
    {"countryCode": "LS", "name": "Lesotho"},
    {"countryCode": "LT", "name": "Lithuania"},
    {"countryCode": "LU", "name": "Luxembourg"},
    {"countryCode": "MO", "name": "Macau"},
    {"countryCode": "MG", "name": "Madagascar"},
    {"countryCode": "MW", "name": "Malawi"},
    {"countryCode": "MY", "name": "Malaysia"},
    {"countryCode": "MV", "name": "Maldives"},
    {"countryCode": "ML", "name": "Mali"},
    {"countryCode": "MT", "name": "Malta"},
    {"countryCode": "MH", "name": "Marshall Islands"},
    {"countryCode": "MQ", "name": "Martinique"},
    {"countryCode": "MR", "name": "Mauritania"},
    {"countryCode": "MU", "name": "Mauritius"},
    {"countryCode": "YT", "name": "Mayotte"},
    {"countryCode": "MX", "name": "Mexico"},
    {"countryCode": "FM", "name": "Micronesia"},
    {"countryCode": "MC", "name": "Monaco"},
    {"countryCode": "MD", "name": "Moldova"},
    {"countryCode": "MN", "name": "Mongolia"},
    {"countryCode": "ME", "name": "Montenegro"},
    {"countryCode": "MS", "name": "Montserrat"},
    {"countryCode": "MA", "name": "Morocco"},
    {"countryCode": "MZ", "name": "Mozambique"},
    {"countryCode": "MM", "name": "Myanmar"},
    {"countryCode": "NA", "name": "Namibia"},
    {"countryCode": "NR", "name": "Nauru"},
    {"countryCode": "NP", "name": "Nepal"},
    {"countryCode": "NL", "name": "Netherlands"},
    {"countryCode": "AN", "name": "Netherlands Antilles"},
    {"countryCode": "NT", "name": "Neutral Zone"},
    {"countryCode": "NC", "name": "New Caledonia"},
    {"countryCode": "NZ", "name": "New Zealand (Aotearoa)"},
    {"countryCode": "NI", "name": "Nicaragua"},
    {"countryCode": "NE", "name": "Niger"},
    {"countryCode": "NG", "name": "Nigeria"},
    {"countryCode": "NU", "name": "Niue"},
    {"countryCode": "NF", "name": "Norfolk Island"},
    {"countryCode": "MP", "name": "Northern Mariana Islands"},
    {"countryCode": "OM", "name": "Oman"},
    {"countryCode": "PK", "name": "Pakistan"},
    {"countryCode": "PW", "name": "Palau"},
    {"countryCode": "PS", "name": "Palestinian Territory, Occupied"},
    {"countryCode": "PA", "name": "Panama"},
    {"countryCode": "PG", "name": "Papua New Guinea"},
    {"countryCode": "PY", "name": "Paraguay"},
    {"countryCode": "PE", "name": "Peru"},
    {"countryCode": "PH", "name": "Philippines"},
    {"countryCode": "PN", "name": "Pitcairn"},
    {"countryCode": "PL", "name": "Poland"},
    {"countryCode": "PT", "name": "Portugal"},
    {"countryCode": "PR", "name": "Puerto Rico"},
    {"countryCode": "QA", "name": "Qatar"},
    {"countryCode": "RE", "name": "Reunion"},
    {"countryCode": "RO", "name": "Romania"},
    {"countryCode": "RU", "name": "Russian Federation"},
    {"countryCode": "RW", "name": "Rwanda"},
    {"countryCode": "GS", "name": "S. Georgia and S. Sandwich Isls."},
    {"countryCode": "SH", "name": "Saint Helena"},
    {"countryCode": "KN", "name": "Saint Kitts and Nevis"},
    {"countryCode": "LC", "name": "Saint Lucia"},
    {"countryCode": "MF", "name": "Saint Martin"},
    {"countryCode": "VC", "name": "Saint Vincent & the Grenadines"},
    {"countryCode": "WS", "name": "Samoa"},
    {"countryCode": "SM", "name": "San Marino"},
    {"countryCode": "ST", "name": "Sao Tome and Principe"},
    {"countryCode": "SA", "name": "Saudi Arabia"},
    {"countryCode": "SN", "name": "Senegal"},
    {"countryCode": "RS", "name": "Serbia"},
    {"countryCode": "YU", "name": "Serbia and Montenegro (former)"},
    {"countryCode": "SC", "name": "Seychelles"},
    {"countryCode": "SL", "name": "Sierra Leone"},
    {"countryCode": "SG", "name": "Singapore"},
    {"countryCode": "SI", "name": "Slovenia"},
    {"countryCode": "SK", "name": "Slovakia"},
    {"countryCode": "SB", "name": "Solomon Islands"},
    {"countryCode": "SO", "name": "Somalia"},
    {"countryCode": "ZA", "name": "South Africa"},
    {"countryCode": "SS", "name": "South Sudan"},
    {"countryCode": "ES", "name": "Spain"},
    {"countryCode": "LK", "name": "Sri Lanka"},
    {"countryCode": "SD", "name": "Sudan"},
    {"countryCode": "SR", "name": "Suriname"},
    {"countryCode": "SJ", "name": "Svalbard & Jan Mayen Islands"},
    {"countryCode": "SZ", "name": "Swaziland"},
    {"countryCode": "SE", "name": "Sweden"},
    {"countryCode": "CH", "name": "Switzerland"},
    {"countryCode": "SY", "name": "Syria"},
    {"countryCode": "TW", "name": "Taiwan"},
    {"countryCode": "TJ", "name": "Tajikistan"},
    {"countryCode": "TZ", "name": "Tanzania"},
    {"countryCode": "TH", "name": "Thailand"},
    {"countryCode": "TG", "name": "Togo"},
    {"countryCode": "TK", "name": "Tokelau"},
    {"countryCode": "TO", "name": "Tonga"},
    {"countryCode": "TT", "name": "Trinidad and Tobago"},
    {"countryCode": "TN", "name": "Tunisia"},
    {"countryCode": "TR", "name": "Turkey"},
    {"countryCode": "TM", "name": "Turkmenistan"},
    {"countryCode": "TC", "name": "Turks and Caicos Islands"},
    {"countryCode": "TV", "name": "Tuvalu"},
    {"countryCode": "UG", "name": "Uganda"},
    {"countryCode": "UA", "name": "Ukraine"},
    {"countryCode": "AE", "name": "United Arab Emirates"},
    {"countryCode": "US", "name": "United States"},
    {"countryCode": "UM", "name": "US Minor Outlying Islands"},
    {"countryCode": "UY", "name": "Uruguay"},
    {"countryCode": "SU", "name": "USSR (former)"},
    {"countryCode": "UZ", "name": "Uzbekistan"},
    {"countryCode": "VU", "name": "Vanuatu"},
    {"countryCode": "VA", "name": "Vatican City State (Holy See)"},
    {"countryCode": "VE", "name": "Venezuela"},
    {"countryCode": "VN", "name": "Viet Nam"},
    {"countryCode": "VG", "name": "British Virgin Islands"},
    {"countryCode": "VI", "name": "Virgin Islands (U.S.)"},
    {"countryCode": "WF", "name": "Wallis and Futuna Islands"},
    {"countryCode": "EH", "name": "Western Sahara"},
    {"countryCode": "YE", "name": "Yemen"},
    {"countryCode": "ZM", "name": "Zambia"},
    {"countryCode": "ZW", "name": "Zimbabwe"}
];
const countryCodeArr = [
    {
    "name": "Afghanistan",
    "dial_code": "+93",
    "code": "AF"
    },
    {
    "name": "Aland Islands",
    "dial_code": "+358",
    "code": "AX"
    },
    {
    "name": "Albania",
    "dial_code": "+355",
    "code": "AL"
    },
    {
    "name": "Algeria",
    "dial_code": "+213",
    "code": "DZ"
    },
    {
    "name": "AmericanSamoa",
    "dial_code": "+1 684",
    "code": "AS"
    },
    {
    "name": "Andorra",
    "dial_code": "+376",
    "code": "AD"
    },
    {
    "name": "Angola",
    "dial_code": "+244",
    "code": "AO"
    },
    {
    "name": "Anguilla",
    "dial_code": "+1 264",
    "code": "AI"
    },
    {
    "name": "Antarctica",
    "dial_code": "+672",
    "code": "AQ"
    },
    {
    "name": "Antigua and Barbuda",
    "dial_code": "+1268",
    "code": "AG"
    },
    {
    "name": "Argentina",
    "dial_code": "+54",
    "code": "AR"
    },
    {
    "name": "Armenia",
    "dial_code": "+374",
    "code": "AM"
    },
    {
    "name": "Aruba",
    "dial_code": "+297",
    "code": "AW"
    },
    {
    "name": "Australia",
    "dial_code": "+61",
    "code": "AU"
    },
    {
    "name": "Austria",
    "dial_code": "+43",
    "code": "AT"
    },
    {
    "name": "Azerbaijan",
    "dial_code": "+994",
    "code": "AZ"
    },
    {
    "name": "Bahamas",
    "dial_code": "+1 242",
    "code": "BS"
    },
    {
    "name": "Bahrain",
    "dial_code": "+973",
    "code": "BH"
    },
    {
    "name": "Bangladesh",
    "dial_code": "+880",
    "code": "BD"
    },
    {
    "name": "Barbados",
    "dial_code": "+1 246",
    "code": "BB"
    },
    {
    "name": "Belarus",
    "dial_code": "+375",
    "code": "BY"
    },
    {
    "name": "Belgium",
    "dial_code": "+32",
    "code": "BE"
    },
    {
    "name": "Belize",
    "dial_code": "+501",
    "code": "BZ"
    },
    {
    "name": "Benin",
    "dial_code": "+229",
    "code": "BJ"
    },
    {
    "name": "Bermuda",
    "dial_code": "+1 441",
    "code": "BM"
    },
    {
    "name": "Bhutan",
    "dial_code": "+975",
    "code": "BT"
    },
    {
    "name": "Bolivia, Plurinational State of",
    "dial_code": "+591",
    "code": "BO"
    },
    {
    "name": "Bosnia and Herzegovina",
    "dial_code": "+387",
    "code": "BA"
    },
    {
    "name": "Botswana",
    "dial_code": "+267",
    "code": "BW"
    },
    {
    "name": "Brazil",
    "dial_code": "+55",
    "code": "BR"
    },
    {
    "name": "British Indian Ocean Territory",
    "dial_code": "+246",
    "code": "IO"
    },
    {
    "name": "Brunei Darussalam",
    "dial_code": "+673",
    "code": "BN"
    },
    {
    "name": "Bulgaria",
    "dial_code": "+359",
    "code": "BG"
    },
    {
    "name": "Burkina Faso",
    "dial_code": "+226",
    "code": "BF"
    },
    {
    "name": "Burundi",
    "dial_code": "+257",
    "code": "BI"
    },
    {
    "name": "Cambodia",
    "dial_code": "+855",
    "code": "KH"
    },
    {
    "name": "Cameroon",
    "dial_code": "+237",
    "code": "CM"
    },
    {
    "name": "Canada",
    "dial_code": "+1",
    "code": "CA"
    },
    {
    "name": "Cape Verde",
    "dial_code": "+238",
    "code": "CV"
    },
    {
    "name": "Cayman Islands",
    "dial_code": "+ 345",
    "code": "KY"
    },
    {
    "name": "Central African Republic",
    "dial_code": "+236",
    "code": "CF"
    },
    {
    "name": "Chad",
    "dial_code": "+235",
    "code": "TD"
    },
    {
    "name": "Chile",
    "dial_code": "+56",
    "code": "CL"
    },
    {
    "name": "China",
    "dial_code": "+86",
    "code": "CN"
    },
    {
    "name": "Christmas Island",
    "dial_code": "+61",
    "code": "CX"
    },
    {
    "name": "Cocos (Keeling) Islands",
    "dial_code": "+61",
    "code": "CC"
    },
    {
    "name": "Colombia",
    "dial_code": "+57",
    "code": "CO"
    },
    {
    "name": "Comoros",
    "dial_code": "+269",
    "code": "KM"
    },
    {
    "name": "Congo",
    "dial_code": "+242",
    "code": "CG"
    },
    {
    "name": "Congo, The Democratic Republic of the Congo",
    "dial_code": "+243",
    "code": "CD"
    },
    {
    "name": "Cook Islands",
    "dial_code": "+682",
    "code": "CK"
    },
    {
    "name": "Costa Rica",
    "dial_code": "+506",
    "code": "CR"
    },
    {
    "name": "Cote d'Ivoire",
    "dial_code": "+225",
    "code": "CI"
    },
    {
    "name": "Croatia",
    "dial_code": "+385",
    "code": "HR"
    },
    {
    "name": "Cuba",
    "dial_code": "+53",
    "code": "CU"
    },
    {
    "name": "Cyprus",
    "dial_code": "+357",
    "code": "CY"
    },
    {
    "name": "Czech Republic",
    "dial_code": "+420",
    "code": "CZ"
    },
    {
    "name": "Denmark",
    "dial_code": "+45",
    "code": "DK"
    },
    {
    "name": "Djibouti",
    "dial_code": "+253",
    "code": "DJ"
    },
    {
    "name": "Dominica",
    "dial_code": "+1 767",
    "code": "DM"
    },
    {
    "name": "Dominican Republic",
    "dial_code": "+1 849",
    "code": "DO"
    },
    {
    "name": "Ecuador",
    "dial_code": "+593",
    "code": "EC"
    },
    {
    "name": "Egypt",
    "dial_code": "+20",
    "code": "EG"
    },
    {
    "name": "El Salvador",
    "dial_code": "+503",
    "code": "SV"
    },
    {
    "name": "Equatorial Guinea",
    "dial_code": "+240",
    "code": "GQ"
    },
    {
    "name": "Eritrea",
    "dial_code": "+291",
    "code": "ER"
    },
    {
    "name": "Estonia",
    "dial_code": "+372",
    "code": "EE"
    },
    {
    "name": "Ethiopia",
    "dial_code": "+251",
    "code": "ET"
    },
    {
    "name": "Falkland Islands (Malvinas)",
    "dial_code": "+500",
    "code": "FK"
    },
    {
    "name": "Faroe Islands",
    "dial_code": "+298",
    "code": "FO"
    },
    {
    "name": "Fiji",
    "dial_code": "+679",
    "code": "FJ"
    },
    {
    "name": "Finland",
    "dial_code": "+358",
    "code": "FI"
    },
    {
    "name": "France",
    "dial_code": "+33",
    "code": "FR"
    },
    {
    "name": "French Guiana",
    "dial_code": "+594",
    "code": "GF"
    },
    {
    "name": "French Polynesia",
    "dial_code": "+689",
    "code": "PF"
    },
    {
    "name": "Gabon",
    "dial_code": "+241",
    "code": "GA"
    },
    {
    "name": "Gambia",
    "dial_code": "+220",
    "code": "GM"
    },
    {
    "name": "Georgia",
    "dial_code": "+995",
    "code": "GE"
    },
    {
    "name": "Germany",
    "dial_code": "+49",
    "code": "DE"
    },
    {
    "name": "Ghana",
    "dial_code": "+233",
    "code": "GH"
    },
    {
    "name": "Gibraltar",
    "dial_code": "+350",
    "code": "GI"
    },
    {
    "name": "Greece",
    "dial_code": "+30",
    "code": "GR"
    },
    {
    "name": "Greenland",
    "dial_code": "+299",
    "code": "GL"
    },
    {
    "name": "Grenada",
    "dial_code": "+1 473",
    "code": "GD"
    },
    {
    "name": "Guadeloupe",
    "dial_code": "+590",
    "code": "GP"
    },
    {
    "name": "Guam",
    "dial_code": "+1 671",
    "code": "GU"
    },
    {
    "name": "Guatemala",
    "dial_code": "+502",
    "code": "GT"
    },
    {
    "name": "Guernsey",
    "dial_code": "+44",
    "code": "GG"
    },
    {
    "name": "Guinea",
    "dial_code": "+224",
    "code": "GN"
    },
    {
    "name": "Guinea-Bissau",
    "dial_code": "+245",
    "code": "GW"
    },
    {
    "name": "Guyana",
    "dial_code": "+595",
    "code": "GY"
    },
    {
    "name": "Haiti",
    "dial_code": "+509",
    "code": "HT"
    },
    {
    "name": "Holy See (Vatican City State)",
    "dial_code": "+379",
    "code": "VA"
    },
    {
    "name": "Honduras",
    "dial_code": "+504",
    "code": "HN"
    },
    {
    "name": "Hong Kong",
    "dial_code": "+852",
    "code": "HK"
    },
    {
    "name": "Hungary",
    "dial_code": "+36",
    "code": "HU"
    },
    {
    "name": "Iceland",
    "dial_code": "+354",
    "code": "IS"
    },
    {
    "name": "India",
    "dial_code": "+91",
    "code": "IN"
    },
    {
    "name": "Indonesia",
    "dial_code": "+62",
    "code": "ID"
    },
    {
    "name": "Iran, Islamic Republic of Persian Gulf",
    "dial_code": "+98",
    "code": "IR"
    },
    {
    "name": "Iraq",
    "dial_code": "+964",
    "code": "IQ"
    },
    {
    "name": "Ireland",
    "dial_code": "+353",
    "code": "IE"
    },
    {
    "name": "Isle of Man",
    "dial_code": "+44",
    "code": "IM"
    },
    {
    "name": "Israel",
    "dial_code": "+972",
    "code": "IL"
    },
    {
    "name": "Italy",
    "dial_code": "+39",
    "code": "IT"
    },
    {
    "name": "Jamaica",
    "dial_code": "+1 876",
    "code": "JM"
    },
    {
    "name": "Japan",
    "dial_code": "+81",
    "code": "JP"
    },
    {
    "name": "Jersey",
    "dial_code": "+44",
    "code": "JE"
    },
    {
    "name": "Jordan",
    "dial_code": "+962",
    "code": "JO"
    },
    {
    "name": "Kazakhstan",
    "dial_code": "+7 7",
    "code": "KZ"
    },
    {
    "name": "Kenya",
    "dial_code": "+254",
    "code": "KE"
    },
    {
    "name": "Kiribati",
    "dial_code": "+686",
    "code": "KI"
    },
    {
    "name": "Korea, Democratic People's Republic of Korea",
    "dial_code": "+850",
    "code": "KP"
    },
    {
    "name": "Korea, Republic of South Korea",
    "dial_code": "+82",
    "code": "KR"
    },
    {
    "name": "Kuwait",
    "dial_code": "+965",
    "code": "KW"
    },
    {
    "name": "Kyrgyzstan",
    "dial_code": "+996",
    "code": "KG"
    },
    {
    "name": "Laos",
    "dial_code": "+856",
    "code": "LA"
    },
    {
    "name": "Latvia",
    "dial_code": "+371",
    "code": "LV"
    },
    {
    "name": "Lebanon",
    "dial_code": "+961",
    "code": "LB"
    },
    {
    "name": "Lesotho",
    "dial_code": "+266",
    "code": "LS"
    },
    {
    "name": "Liberia",
    "dial_code": "+231",
    "code": "LR"
    },
    {
    "name": "Libyan Arab Jamahiriya",
    "dial_code": "+218",
    "code": "LY"
    },
    {
    "name": "Liechtenstein",
    "dial_code": "+423",
    "code": "LI"
    },
    {
    "name": "Lithuania",
    "dial_code": "+370",
    "code": "LT"
    },
    {
    "name": "Luxembourg",
    "dial_code": "+352",
    "code": "LU"
    },
    {
    "name": "Macao",
    "dial_code": "+853",
    "code": "MO"
    },
    {
    "name": "Macedonia",
    "dial_code": "+389",
    "code": "MK"
    },
    {
    "name": "Madagascar",
    "dial_code": "+261",
    "code": "MG"
    },
    {
    "name": "Malawi",
    "dial_code": "+265",
    "code": "MW"
    },
    {
    "name": "Malaysia",
    "dial_code": "+60",
    "code": "MY"
    },
    {
    "name": "Maldives",
    "dial_code": "+960",
    "code": "MV"
    },
    {
    "name": "Mali",
    "dial_code": "+223",
    "code": "ML"
    },
    {
    "name": "Malta",
    "dial_code": "+356",
    "code": "MT"
    },
    {
    "name": "Marshall Islands",
    "dial_code": "+692",
    "code": "MH"
    },
    {
    "name": "Martinique",
    "dial_code": "+596",
    "code": "MQ"
    },
    {
    "name": "Mauritania",
    "dial_code": "+222",
    "code": "MR"
    },
    {
    "name": "Mauritius",
    "dial_code": "+230",
    "code": "MU"
    },
    {
    "name": "Mayotte",
    "dial_code": "+262",
    "code": "YT"
    },
    {
    "name": "Mexico",
    "dial_code": "+52",
    "code": "MX"
    },
    {
    "name": "Micronesia, Federated States of Micronesia",
    "dial_code": "+691",
    "code": "FM"
    },
    {
    "name": "Moldova",
    "dial_code": "+373",
    "code": "MD"
    },
    {
    "name": "Monaco",
    "dial_code": "+377",
    "code": "MC"
    },
    {
    "name": "Mongolia",
    "dial_code": "+976",
    "code": "MN"
    },
    {
    "name": "Montenegro",
    "dial_code": "+382",
    "code": "ME"
    },
    {
    "name": "Montserrat",
    "dial_code": "+1664",
    "code": "MS"
    },
    {
    "name": "Morocco",
    "dial_code": "+212",
    "code": "MA"
    },
    {
    "name": "Mozambique",
    "dial_code": "+258",
    "code": "MZ"
    },
    {
    "name": "Myanmar",
    "dial_code": "+95",
    "code": "MM"
    },
    {
    "name": "Namibia",
    "dial_code": "+264",
    "code": "NA"
    },
    {
    "name": "Nauru",
    "dial_code": "+674",
    "code": "NR"
    },
    {
    "name": "Nepal",
    "dial_code": "+977",
    "code": "NP"
    },
    {
    "name": "Netherlands",
    "dial_code": "+31",
    "code": "NL"
    },
    {
    "name": "Netherlands Antilles",
    "dial_code": "+599",
    "code": "AN"
    },
    {
    "name": "New Caledonia",
    "dial_code": "+687",
    "code": "NC"
    },
    {
    "name": "New Zealand",
    "dial_code": "+64",
    "code": "NZ"
    },
    {
    "name": "Nicaragua",
    "dial_code": "+505",
    "code": "NI"
    },
    {
    "name": "Niger",
    "dial_code": "+227",
    "code": "NE"
    },
    {
    "name": "Nigeria",
    "dial_code": "+234",
    "code": "NG"
    },
    {
    "name": "Niue",
    "dial_code": "+683",
    "code": "NU"
    },
    {
    "name": "Norfolk Island",
    "dial_code": "+672",
    "code": "NF"
    },
    {
    "name": "Northern Mariana Islands",
    "dial_code": "+1 670",
    "code": "MP"
    },
    {
    "name": "Norway",
    "dial_code": "+47",
    "code": "NO"
    },
    {
    "name": "Oman",
    "dial_code": "+968",
    "code": "OM"
    },
    {
    "name": "Pakistan",
    "dial_code": "+92",
    "code": "PK"
    },
    {
    "name": "Palau",
    "dial_code": "+680",
    "code": "PW"
    },
    {
    "name": "Palestinian Territory, Occupied",
    "dial_code": "+970",
    "code": "PS"
    },
    {
    "name": "Panama",
    "dial_code": "+507",
    "code": "PA"
    },
    {
    "name": "Papua New Guinea",
    "dial_code": "+675",
    "code": "PG"
    },
    {
    "name": "Paraguay",
    "dial_code": "+595",
    "code": "PY"
    },
    {
    "name": "Peru",
    "dial_code": "+51",
    "code": "PE"
    },
    {
    "name": "Philippines",
    "dial_code": "+63",
    "code": "PH"
    },
    {
    "name": "Pitcairn",
    "dial_code": "+872",
    "code": "PN"
    },
    {
    "name": "Poland",
    "dial_code": "+48",
    "code": "PL"
    },
    {
    "name": "Portugal",
    "dial_code": "+351",
    "code": "PT"
    },
    {
    "name": "Puerto Rico",
    "dial_code": "+1 939",
    "code": "PR"
    },
    {
    "name": "Qatar",
    "dial_code": "+974",
    "code": "QA"
    },
    {
    "name": "Romania",
    "dial_code": "+40",
    "code": "RO"
    },
    {
    "name": "Russia",
    "dial_code": "+7",
    "code": "RU"
    },
    {
    "name": "Rwanda",
    "dial_code": "+250",
    "code": "RW"
    },
    {
    "name": "Reunion",
    "dial_code": "+262",
    "code": "RE"
    },
    {
    "name": "Saint Barthelemy",
    "dial_code": "+590",
    "code": "BL"
    },
    {
    "name": "Saint Helena, Ascension and Tristan Da Cunha",
    "dial_code": "+290",
    "code": "SH"
    },
    {
    "name": "Saint Kitts and Nevis",
    "dial_code": "+1 869",
    "code": "KN"
    },
    {
    "name": "Saint Lucia",
    "dial_code": "+1 758",
    "code": "LC"
    },
    {
    "name": "Saint Martin",
    "dial_code": "+590",
    "code": "MF"
    },
    {
    "name": "Saint Pierre and Miquelon",
    "dial_code": "+508",
    "code": "PM"
    },
    {
    "name": "Saint Vincent and the Grenadines",
    "dial_code": "+1 784",
    "code": "VC"
    },
    {
    "name": "Samoa",
    "dial_code": "+685",
    "code": "WS"
    },
    {
    "name": "San Marino",
    "dial_code": "+378",
    "code": "SM"
    },
    {
    "name": "Sao Tome and Principe",
    "dial_code": "+239",
    "code": "ST"
    },
    {
    "name": "Saudi Arabia",
    "dial_code": "+966",
    "code": "SA"
    },
    {
    "name": "Senegal",
    "dial_code": "+221",
    "code": "SN"
    },
    {
    "name": "Serbia",
    "dial_code": "+381",
    "code": "RS"
    },
    {
    "name": "Seychelles",
    "dial_code": "+248",
    "code": "SC"
    },
    {
    "name": "Sierra Leone",
    "dial_code": "+232",
    "code": "SL"
    },
    {
    "name": "Singapore",
    "dial_code": "+65",
    "code": "SG"
    },
    {
    "name": "Slovakia",
    "dial_code": "+421",
    "code": "SK"
    },
    {
    "name": "Slovenia",
    "dial_code": "+386",
    "code": "SI"
    },
    {
    "name": "Solomon Islands",
    "dial_code": "+677",
    "code": "SB"
    },
    {
    "name": "Somalia",
    "dial_code": "+252",
    "code": "SO"
    },
    {
    "name": "South Africa",
    "dial_code": "+27",
    "code": "ZA"
    },
    {
    "name": "South Georgia and the South Sandwich Islands",
    "dial_code": "+500",
    "code": "GS"
    },
    {
    "name": "Spain",
    "dial_code": "+34",
    "code": "ES"
    },
    {
    "name": "Sri Lanka",
    "dial_code": "+94",
    "code": "LK"
    },
    {
    "name": "Sudan",
    "dial_code": "+249",
    "code": "SD"
    },
    {
    "name": "Suriname",
    "dial_code": "+597",
    "code": "SR"
    },
    {
    "name": "Svalbard and Jan Mayen",
    "dial_code": "+47",
    "code": "SJ"
    },
    {
    "name": "Swaziland",
    "dial_code": "+268",
    "code": "SZ"
    },
    {
    "name": "Sweden",
    "dial_code": "+46",
    "code": "SE"
    },
    {
    "name": "Switzerland",
    "dial_code": "+41",
    "code": "CH"
    },
    {
    "name": "Syrian Arab Republic",
    "dial_code": "+963",
    "code": "SY"
    },
    {
    "name": "Taiwan",
    "dial_code": "+886",
    "code": "TW"
    },
    {
    "name": "Tajikistan",
    "dial_code": "+992",
    "code": "TJ"
    },
    {
    "name": "Tanzania, United Republic of Tanzania",
    "dial_code": "+255",
    "code": "TZ"
    },
    {
    "name": "Thailand",
    "dial_code": "+66",
    "code": "TH"
    },
    {
    "name": "Timor-Leste",
    "dial_code": "+670",
    "code": "TL"
    },
    {
    "name": "Togo",
    "dial_code": "+228",
    "code": "TG"
    },
    {
    "name": "Tokelau",
    "dial_code": "+690",
    "code": "TK"
    },
    {
    "name": "Tonga",
    "dial_code": "+676",
    "code": "TO"
    },
    {
    "name": "Trinidad and Tobago",
    "dial_code": "+1 868",
    "code": "TT"
    },
    {
    "name": "Tunisia",
    "dial_code": "+216",
    "code": "TN"
    },
    {
    "name": "Turkey",
    "dial_code": "+90",
    "code": "TR"
    },
    {
    "name": "Turkmenistan",
    "dial_code": "+993",
    "code": "TM"
    },
    {
    "name": "Turks and Caicos Islands",
    "dial_code": "+1 649",
    "code": "TC"
    },
    {
    "name": "Tuvalu",
    "dial_code": "+688",
    "code": "TV"
    },
    {
    "name": "Uganda",
    "dial_code": "+256",
    "code": "UG"
    },
    {
    "name": "Ukraine",
    "dial_code": "+380",
    "code": "UA"
    },
    {
    "name": "United Arab Emirates",
    "dial_code": "+971",
    "code": "AE"
    },
    {
    "name": "United Kingdom",
    "dial_code": "+44",
    "code": "GB"
    },
    {
    "name": "United States",
    "dial_code": "+1",
    "code": "US"
    },
    {
    "name": "Uruguay",
    "dial_code": "+598",
    "code": "UY"
    },
    {
    "name": "Uzbekistan",
    "dial_code": "+998",
    "code": "UZ"
    },
    {
    "name": "Vanuatu",
    "dial_code": "+678",
    "code": "VU"
    },
    {
    "name": "Venezuela, Bolivarian Republic of Venezuela",
    "dial_code": "+58",
    "code": "VE"
    },
    {
    "name": "Vietnam",
    "dial_code": "+84",
    "code": "VN"
    },
    {
    "name": "Virgin Islands, British",
    "dial_code": "+1 284",
    "code": "VG"
    },
    {
    "name": "Virgin Islands, U.S.",
    "dial_code": "+1 340",
    "code": "VI"
    },
    {
    "name": "Wallis and Futuna",
    "dial_code": "+681",
    "code": "WF"
    },
    {
    "name": "Yemen",
    "dial_code": "+967",
    "code": "YE"
    },
    {
    "name": "Zambia",
    "dial_code": "+260",
    "code": "ZM"
    },
    {
    "name": "Zimbabwe",
    "dial_code": "+263",
    "code": "ZW"
    }
];
let replaceName = countryCodeArr.map(({dial_code,...rest}) => ({...rest,label:dial_code}));
let replaceDial_code = replaceName.map(({name,...rest}) => ({...rest,value:name}));
let removeCode = replaceDial_code.map(({code,...rest}) => ({...rest}));
function setLabelAndValue() {
    for(var i = 0; i < removeCode.length; i++){
        removeCode[i].value = countryCodeArr[i].dial_code
        removeCode[i].label = `${countryCodeArr[i].dial_code} ${countryCodeArr[i].name}`
    }
};
setLabelAndValue();
export const countryCodes = removeCode;


/* const fetchInfo = () => {
    return fetch("http://offshorequalific.test/wp-json/wp/v2/registration-settings")
    .then((res) => res.json())
    .then((d) => data[d])
    .then((response) => {
        if (!response.ok) {
            
        }
        return response.json();
    })
    .then(json => {x = json.value})
    .catch((error) => {
        
    })
}
let x = fetchInfo()


export const registrationSettings = fetchInfo();
console.log(x) */